import { UrlRoute } from 'enums';
import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { DomainObject } from 'types';

interface ToolbarHookProps<TObject> {
  items: TObject[];
  level: number;
  urlRoute: UrlRoute;
  itemId?: string;
}

export function useTransitionButtons<TObject extends DomainObject>({
  items,
  urlRoute,
  itemId,
  level,
}: ToolbarHookProps<TObject>) {
  const history = useHistory();

  return useMemo(() => {
    if (!itemId) {
      return {};
    }

    const indexOfSelectedItem = items.findIndex((i) => i.id === itemId);

    const nextId = items?.[indexOfSelectedItem + 1]?.id;
    const previousId = items?.[indexOfSelectedItem - 1]?.id;

    const handleNext = nextId
      ? () => history.push(`${urlRoute}/${level}/${nextId}`)
      : undefined;
    const handlePrevious = previousId
      ? () => history.push(`${urlRoute}/${level}/${previousId}`)
      : undefined;

    return { handleNext, handlePrevious };
  }, [history, itemId, items, level, urlRoute]);
}
